import React from 'react';
import { usePreviousPatientReportsQuery } from '~/api/patientReports/usePreviousPatientReportsQuery';
import { PreviousReport } from './PreviousReport';
export const PreviousReportsList = (props) => {
    const { patientId, enabled } = props;
    const query = usePreviousPatientReportsQuery(patientId, enabled);
    if (query.isFetching) {
        return React.createElement("div", null, "Loading...");
    }
    if (query.isError) {
        return (React.createElement("div", null,
            "We couldn\u2019t load previous reports.",
            ' ',
            React.createElement("button", { type: "button", className: "btn-rhythm btn-xs", onClick: () => query.refetch() }, "Try Again")));
    }
    if (query.isSuccess) {
        if (query.data.length === 0) {
            return React.createElement("div", null, "There are no reports to show ");
        }
        return (React.createElement("div", { className: "space-y-4 w-60" }, query.data.map((report, index) => (React.createElement(PreviousReport, { key: index, report: report })))));
    }
    return null;
};
